/* eslint-disable import/no-cycle */
import axios from 'axios';
import exploreMap from '@/plugins/exploreGraphMap';
import addToThoughtMapUtil from '@/utils/addToThoughtMapUtil';
import graphReactor from '@/graphReactor';
import { comboPlate } from '@/plugins/plate';

export default {
  async getGraph({ commit }, graphId) {
    const response = await axios.get(`${process.env.VUE_APP_AXIOS_URI}/g6graph/${graphId}`);
    const fetchedData = response.data.g6_data.gdata;
    console.log('fetchedData', fetchedData.combos);
    commit('SET_G6_EXPLORE_DATA', fetchedData);
  },

  async comoPropOperation({ dispatch }, { combosList, nodeList, fetchList }) {
    combosList.forEach((item) => {
      if (item) {
        const comboBoiler = comboPlate(item);
        graphReactor.exploreInstance.addItem('combo', comboBoiler);
      }
    });

    nodeList.forEach((nodeBoiler) => {
      const EdgeStore = [];

      const findNode = graphReactor.exploreInstance.find('node', (node) => node.get('model').id === nodeBoiler.id);

      if (findNode) {
        const nodeModel = findNode.get('model');
        console.log('Node Exist', nodeModel);
        const currentNodeEdges = findNode.getEdges();
        currentNodeEdges.forEach((edge) => {
          EdgeStore.push(edge.get('model'));
        });
        graphReactor.exploreInstance.removeItem(findNode);
        graphReactor.exploreInstance.addItem('node', nodeBoiler);
      } else {
        console.log('nodeBoiler', nodeBoiler);
        graphReactor.exploreInstance.addItem('node', nodeBoiler);
      }

      EdgeStore.forEach((edge) => {
        graphReactor.exploreInstance.addItem('edge', edge);
      });

      graphReactor.exploreInstance.updateLayout();
    });

    fetchList.forEach((item) => {
      dispatch('exploreGraphFetch', item.trim());
    });
  },

  async deleteGraph({ commit, dispatch }, graphId) {
    const response = await axios.delete(`${process.env.VUE_APP_AXIOS_URI}/g6graph/${graphId}`);
    commit('SET_GRAPH_DELETED_DATA', response.data);
    dispatch('eventToEventStore', {
      verb: 'DELETED_GRAPH',
      value: {
        // eslint-disable-next-line
        graphId: response.data._id,
      },
    }, { root: true });
  },

  async updateGraph({ dispatch }, payload) {
    const response = await axios.put(`${process.env.VUE_APP_AXIOS_URI}/g6graph/${payload.id}`, {
      g6_data: {
        gdata: payload.gdata,
        graph_name: payload.graph_name,
        graph_type: payload.graph_type,
      },
      tags: payload.graph_tags,
    });
    console.log(response.data);
    // commit('SET_GRAPH_UPDATED_DATA', response.data);
    dispatch('eventToEventStore', {
      verb: 'UPDATED_GRAPH',
      value: {
        // eslint-disable-next-line
        graphId: response.data._id,
      },
    }, { root: true });
  },

  async exploreGraphUnResponded({ commit }, exploreEntity) {
    const exploreResponseObj = await axios.post(`${process.env.VUE_APP_AXIOS_URI}/explore`, {
      query: exploreEntity,
    });
    const exploreMapResponse = await exploreMap(exploreResponseObj.data.links);
    // commit('pushMyNode', exploreEntity);
    const payload = { exploreMapResponse, exploreEntity };
    commit('setExploreGraphExpansion', payload);
  },

  async csvDataExpand({ commit }, data) {
    commit('EXPAND_DATA', data);
  },

  async exploreGraphFetch({ dispatch, commit, rootState }, exploreEntity) {
    const exploreResponseObj = await axios.post(`${process.env.VUE_APP_AXIOS_URI}/explore/links`, {
      query: exploreEntity,
      limit: rootState.explore_data_range,
    });

    // combo fix
    await dispatch('saveG6ExploreData');

    const exploreMapResponse = await exploreMap(exploreResponseObj.data.links);
    commit('pushMyNode', exploreEntity);
    const payload = { exploreMapResponse, exploreEntity };
    // console.log('Explore Data', exploreMapResponse);
    commit('setExploreGraphExpansion', payload);
    // dispatch('saveG6ExploreData');
  },

  async updateLabelFromData({ commit, state }, payload) {
    const g6NodeData = state.g6_explore_data.nodes;
    const myNode = payload.node;
    myNode.label = payload.label;
    g6NodeData[g6NodeData.findIndex((el) => el.id === payload.node.id)] = myNode;
    const finalData = {
      nodes: g6NodeData,
      edges: state.g6_explore_data.edges,
      combos: state.g6_explore_data.combos,
    };
    commit('SET_G6_EXPLORE_DATA', finalData);
  },

  async deleteNodeFromData({ commit, state }, data) {
    const finalNodes = state.g6_explore_data.nodes.filter((i) => i.id !== data.id);
    const finalData = {
      nodes: finalNodes,
      edges: state.g6_explore_data.edges,
      combos: state.g6_explore_data.combos,
    };
    commit('SET_G6_EXPLORE_DATA', finalData);
  },

  async addToThoughtMap({ commit, state, rootState }, payload) {
    const currentWord = rootState.current_selected_entity.word || 'No selected entity';
    const currentGraphData = state.g6_explore_data;
    const userName = rootState.auth.user.username;

    const newData = addToThoughtMapUtil({
      currentWord, currentGraphData, userName, payload,
    });
    console.log('newData.combos', newData.combos);
    commit('SET_G6_EXPLORE_DATA', newData);
  },

  async saveG6ExploreData({ commit }) {
    const data = graphReactor.exploreInstance.save();
    console.log('data from saveG6ExploreData', data);
    commit('SET_G6_EXPLORE_DATA', data);
  },

  async setExploreData({ commit }, payload) {
    commit('SET_G6_EXPLORE_DATA', payload);
  },

  async exploreThoughtMap({ commit, state }, payload) {
    const currentGraphData = state.g6_explore_data;
    const response = await axios.get(`${process.env.VUE_APP_AXIOS_URI}/g6graph/${payload.graphId}`);
    console.log(response.data);
    const exploreGraphData = response.data.g6_data.gdata;
    const exploredNodes = exploreGraphData.nodes.map((el) => {
      const newEl = el;
      newEl.comboId = `${payload.graphId}`;
      return newEl;
    });
    const exploredEdges = exploreGraphData.edges;

    // const combo = {
    //   id: `${payload.graphId}`,
    //   ebel: payload.graphName,
    // }

    currentGraphData.nodes = [...currentGraphData.nodes, ...exploredNodes];

    const uniqueNodes = currentGraphData.nodes.reduce((uniqueMap, node) => {
      if (uniqueMap[node.id] === undefined) {
        // eslint-disable-next-line no-param-reassign
        uniqueMap[node.id] = node;
      }
      return uniqueMap;
    }, {});

    currentGraphData.nodes = Object.values(uniqueNodes);
    currentGraphData.edges = [...currentGraphData.edges, ...exploredEdges];
    if (exploreGraphData.combos === undefined) {
      currentGraphData.combos = [...currentGraphData.combos];
    } else {
      currentGraphData.combos = [...currentGraphData.combos, ...exploreGraphData.combos];
    }

    commit('SET_G6_EXPLORE_DATA', currentGraphData);
  },

  async dimensionDataFetch({ commit, getters, state }, payloadType) {
    const dimensionResponse = await axios.post(`${process.env.VUE_APP_AXIOS_URI}/dimension`, {
      nodeList: getters.getDimensionArray,
      pList: state.pList[payloadType],
      caseType: payloadType,
    });
    const dimensionData = dimensionResponse.data;
    console.log('dimensionData', dimensionData);
    commit('SET_DIMENSION_DATA', dimensionData);
  },
};
